export default "__VITE_ASSET__c1e077c9__"